/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function() {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    position -= 94 + 20;

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//ページ遷移後のアンカーリンク位置調整
$(function(){
  var headerH = 94 + 20;

  $(window).on("load", function(){
    if(location.hash !== ""){
      var targetOffset = $(location.hash).offset().top;
      $(window).scrollTop(targetOffset - headerH);
    }
  });
});


//スライダー
$(function(){
  $('.home-links__slider').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
//      autoplay: true,
//      autoplaySpeed: 3000,
//      fade: true,
//      speed: 1000,
//      pauseOnFocus: false,
//      pauseOnHover: false,
//      pauseOnDotsHover: false,
      arrows: true,
      dots: true,
      variableWidth: true,
      infinite: false
    });
  });
});

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.l-body.-home').each(function (index, element) {
    const enabledScript = true;
    
    const $root = $(this);
    const $inner1 = $root.find('.home-con__inner');
    const $inner2 = $root.find('.home-con__inner2');

    run();

    $(window).on('scroll resize', function () {
      run();
    });

    function run() {
      if(!enabledScript) return false;

      if(window.matchMedia('(max-width: 991px)')) {
        $inner1.removeAttr('style');
        $inner2.removeAttr('style');
      } else  {
        let scY = $(window).scrollTop();
  
        $inner1.css({
          'margin-top': scY
        });
  
        $inner2.css({
          'margin-top': scY * -1
        });
      }
    }
  });
});

$(function(){
  $('.l-header').each(function (index, element) {
    const $hd = $(this);
    const $body = $('.l-body');
    const $main = $('.l-main');
    const $con = $('.page-con');
    let timer;

    if($body.hasClass('-home')) {
      return false;
    }

    run();

    $(window).on('scroll resize', function () {
      run();
    });

    function run() {
      if($(window).scrollTop() > $main.offset().top) {
        $hd.addClass('is-fix');

        clearInterval(timer);
        timer = setTimeout(function(){
          $hd.addClass('is-fix2');
        }, 10)
      } else {
        $hd.removeClass('is-fix2');

        clearInterval(timer);
        timer = setTimeout(function(){
          $hd.removeClass('is-fix');
        }, 10)
      }

      if($(window).scrollTop() > $con.offset().top) {
        $hd.addClass('is-show');
      } else {
        $hd.removeClass('is-show');
      }
    }
  });
});

$(function(){
  $('.faq-con__dt').each(function (index, element) {
    const $dt = $(this);
    const $dd = $dt.parent().next('dd');

    $dt.on('click', function () {
      $dt.toggleClass('is-on');
      $dd.stop().slideToggle(300);
    });
  });
});

$(function(){
  $('.access-con__label button').each(function (index, element) {
    const $dt = $(this);
    const $dd = $dt.parent().next('div');

    $dt.on('click', function () {
      $dt.toggleClass('is-on');
      $dd.stop().slideToggle(300);
    });
  });
});

$(function(){
  $('.p-hd__menuSP button').each(function (index, element) {
    const $menu = $(this);
    const $nav = $('.p-hd__nav');

    $menu.on('click', function () {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  });
});

$(function(){
  $('.p-hd__nav .-parent button').each(function (index, element) {
    const $btn = $(this);
    const $list = $btn.next('ul');
    let winW = $(window).innerWidth();
    let winWOld = winW;

    $btn.on('click', function () {
      $btn.toggleClass('is-on');
      $list.stop().slideToggle(300);
    });

    $(window).on('resize', function () {
      winWOld = winW;
      winW = $(window).innerWidth();

      if(winW != winWOld) {
        $btn.removeClass('is-on');
        $list.removeAttr('style');
      }
    });
  });
});

$(function(){
  $('.js-tigcon-close').each(function (index, element) {
    $(this).on('click', function () {
      $('.l-body').removeClass('tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
      $('.l-body').addClass('home-main-open');
    });
  });
});

// Tig iframe関連処理
$(function(){
  window.addEventListener('message', function(event) {
    if (event.data.type === 'TigIframe#event#onReady') {
      console.log('TigIframe#event#onReady');
    } else if (event.data.type === 'TigIframe#event#onStock') {
      console.log('TigIframe#event#onStock');
    } else if (event.data.type === 'tig.click_item') {
      console.log('tig.click_item', event.data);
      // URL空でストックが発生しないアイテムは TigIframe#event#onStock イベントが発生しないが、
      // Tigアイテムのcustomデータに以下のjsonを入れると当該アイテムタップ時にこの tig.click_item イベントが発生する
      //   { "iframe_events": { "click_item": true } }
      // event.data.item にアイテム情報が入っているのでidなどを取得して処理する
      switch (event.data.item.id) {
        case 1714621: // モーダル1 合宿の料金表
          $('.l-body').removeClass('home-main-open tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
          $('.l-body').addClass('tigcon-open1');
          break;
        case 1714622: // モーダル2 通学の普通免許の料金表
          $('.l-body').removeClass('home-main-open tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
          $('.l-body').addClass('tigcon-open2');
          break;
        case 1714623: // モーダル3 アクセスマップ
          $('.l-body').removeClass('home-main-open tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
          $('.l-body').addClass('tigcon-open3');
          break;
        case 1714624: // モーダル4 お知らせ
          $('.l-body').removeClass('home-main-open tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
          $('.l-body').addClass('tigcon-open4');
          break;
        case 1714625: // モーダル5 周辺グルメ
          $('.l-body').removeClass('home-main-open tigcon-open1 tigcon-open2 tigcon-open3 tigcon-open4 tigcon-open5');
          $('.l-body').addClass('tigcon-open5');
          break;
      }
      $(window).scrollTop(0);
    }
  });
});


//スライダー
$(function(){
  $('.camping-calendar__slider').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      arrows: true,
      dots: true
    });
  });
});